export default __webpack_public_path__ + "static/media/foster_jackson.e984b430.png";